import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
  AfterViewChecked,
  ChangeDetectorRef,
} from '@angular/core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssetService } from 'src/app/_services/asset.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { jsPDF } from 'jspdf';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ColDef, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { QrExportService } from 'src/app/_services/qr-export.service';
import { ServerRequest } from 'src/app/_models/global.data.model';
import { TableHeaderToolTipComponent } from 'src/app/shared/table-header-tool-tip/table-header-tool-tip.component';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import * as _ from 'lodash';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { Global } from 'src/app/_utilities/global';
import { SettingService } from 'src/app/_services/admin/setting.service';
import { environment } from 'src/environments/environment';

let dateFormateChange: any;

@Component({
  selector: 'app-bulk-export-qr',
  templateUrl: './bulk-export-qr.component.html',
  styleUrls: ['./bulk-export-qr.component.scss'],
  standalone: false,
})
export class BulkExportQrComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy, AfterViewChecked
{
  translate: any;
  submitTouched: boolean = true;

  fileFormat: any = [
    { name: 'PDF', value: 'pdf' },
    { name: 'PNG(Zip File)', value: 'png' },
  ];

  qrCodeSize: any = [
    { name: '0.75” (19mm) - Compact', value: 'small' },
    { name: '1” (25mm) - Standard', value: 'medium' },
    { name: '1.5” (38mm) - Large', value: 'large' },
    { name: '2” (50mm) - Extra Large', value: 'xlarge' },
  ];

  pageLayout: any = [
    { name: '4 per page (2x2)', value: 'portrait' },
    { name: '6 per page (2x3)', value: 'landscape' },
    { name: '12 per page (3x4)', value: 'a4' },
    { name: '24 per page (4x6)', value: 'a5' },
  ];

  filePageLayout: any;
  private sizeMmMap: any = {
    small: 19,
    medium: 25,
    large: 38,
    xlarge: 50,
  };

  exportData: any = {
    selectedFileFormat: null,
    selectedQrCodeSize: null,
    selectedPageLayout: null,
  };

  assets: any[] = [];
  assetName: string = '';
  selectedAsset: any;
  displayAssetTable: boolean = false;

  assetTypes: any;
  assetStatus: any;
  dateRange!: any;
  filter: any = {
    assetStatuses: null,
    assetTypes: null,
    fromDate: null,
    toDate: null,
  };

  @ViewChild('myCalendar', { static: false })
  private myCalendar: any;

  @ViewChildren('qrItem', { read: ElementRef })
  private qrItems!: QueryList<ElementRef>;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[] = [];
  defaultColDef: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  gridOptions: any;
  overlayNoRowsTemplate!: string;
  currentRecordNumber: any;
  rowSelection: any = 'multiple';
  totalRecords: any;
  noAssets: boolean = false;
  noAssetsIcon: boolean = false;
  loadTable: number = 0;
  searchValue: any;
  bodyHeight: number = 0;

  @ViewChild('topElement')
  topElement!: ElementRef;

  bodyHeightleft: number = 0;

  qrexportForm: UntypedFormGroup;
  selectAllChecked: boolean = false;
  selectedAssetData: any[] = [];

  submitFromData: any = {
    selectedIds: [],
    selectedAll: false,
    includeChildren: false,
    search: '',
    assetTypeIds: null,
    statusId: 1,
    createdFrom: null,
    createdTo: null,
  };

  selectedAssetserialNos: any[] = [];
  selectedIdSet: Set<string> = new Set();
  searchValueData: boolean = false;

  private readonly headerIdMap: { [colId: string]: string } = {
    name: 'Tbl_HeadAssetName',
    serialNo: 'Tbl_HeadAssetSerialNo',
    assetsCode: 'Tbl_HeadAssetCode',
    'assetsType.name': 'Tbl_HeadAssetType',
    createdDate: 'Tbl_HeadCreatedDate',
    'status.name': 'Tbl_HeadStatus',
  };
  addonFeature: any = {};
  encryptedTenantId: any;
  lang: any;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private assetService: AssetService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private qrExportService: QrExportService,
    private cdr: ChangeDetectorRef,
    private auth: AuthenticationService,
    private util: UtilServiceService,
    private settingService: SettingService,
  ) {
    super();

    this.gridOptions = {
      pagination: true,
      cacheBlockSize: 25,
      rowModelType: 'infinite',
      sortingOrder: ['desc', 'asc'],
      onGridSizeChanged: (params: any) => {
        params.api.sizeColumnsToFit();
      },
      tooltipShowDelay: 100,
      rowSelection: 'multiple',
      rowMultiSelectWithClick: true,
      onRowSelected: (e: any) => this.onRowSelected(e),
      onSelectionChanged: () => this.onSelectionChanged(),
      onFirstDataRendered: () => {
        Global.setHeaderIds(this.headerIdMap);
      },
      
    };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };

    this.qrexportForm = new UntypedFormGroup({
      fileFormat: new UntypedFormControl(null, [Validators.required]),
      qrCodeSize: new UntypedFormControl(null, [Validators.required]),
      pageLayout: new UntypedFormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    dateFormateChange = this.auth.getUserTimezone();
    this.filePageLayout = _.cloneDeep(this.pageLayout);
    this.getLanguageData();

  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
           this.addonFeature = this.auth.getAddonFeatureLists();
            if(this.addonFeature.addonQRSCANFORM === 'QR_SCAN_FORM'){
            this.getEncryptedTenantId();
            }
            
          this.initializeColumns();
          this.getFilterData();
        }
      })
    );
  }

  // <!---- generate code based on barcode type and addon feature 'QR_SCAN_FORM' -->
    getEncryptedTenantId() {
      this.settingService.getJOSettings().subscribe((res:any)=>{
      this.push(
        this.assetService.getEncryptedTenantId(this.auth.getTenantId()).subscribe((resp) => {
          if (resp) {
            this.encryptedTenantId = resp.encryptedTenantId
            this.lang = res.language ? res.language : 'en'
            //this.encryptedTenantId = environment.qrFromUrl + "?tenantId=" + encryptedTenantId + "&serialNo=" + this.assetData.serialNo+ "&lang=" + lang+"&formType=asset";
            console.log(this.encryptedTenantId,"encryptedTenantId")
          }
        })
      );
    })
    }
    
  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate =
      "<div class='not-found-image'><span>" +
      "<img src='assets/svg/empty-state.svg' alt='No Records Found' />" +
      this.translate?.general.messages.noRecordsFound +
      '</span> </div>';

    const newData = [
      {
        headerName: this.translate?.asset.fields.name.singular,
        field: 'name',
        width: 80,
        headerTooltip: '#',
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.data) {
            return params.data.name ? params.data.name : '-';
          }
          return '-';
        },
      },
      {
        headerName: this.translate?.asset.fields.serialNo.singular,
        field: 'serialNo',
        width: 80,
        headerTooltip: '#',
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.data) {
            return params.data.serialNo ? params.data.serialNo : '-';
          }
          return '-';
        },
      },
      {
        headerName:
          this.translate?.asset.label.singular +
          ' ' +
          this.translate?.asset.fields.code.singular,
        field: 'assetsCode',
        width: 80,
        headerTooltip: '#',
        resizable: true,
      },
      {
        headerName: this.translate?.asset.fields.type.singular,
        field: 'assetsType.name',
        width: 80,
        headerTooltip: '#',
        resizable: true,
      },
      {
        headerName: this.translate?.asset.fields.createdDate.singular,
        field: 'createdDate',
        width: 80,
        headerTooltip: '#',
        resizable: true,
        valueFormatter: this.dateFormateChange,
      },
      {
        headerName: this.translate?.asset.fields.status.singular,
        field: 'status.name',
        width: 80,
        headerTooltip: '#',
        resizable: true,
        cellRenderer: function (params: any) {
          if (params.data && params.data.status) {
            const data = params.data.status;
            return (
              ' <span class="p-mr-2  p-tag p-component" style="background-color:' +
              data.colorCode +
              "50 !important ;color:" +
              '#212121' +
              '"><span class="p-tag-value">' +
              data.name +
              '</span></span>'
            );
          }
          return '';
        },
      },
      {
        headerName: this.translate?.general.buttons.select2.singular,
        field: '',
        width: 80,
        headerClass: 'marging-auto hide-action-border',
        headerTooltip: '#',
        cellStyle: (params: any) => {
          if (params.data) {
            return params.data.disabled
              ? { 'pointer-events': 'none', opacity: '0.4' }
              : { 'pointer-events': 'auto', opacity: '1' };
          }
          return {};
        },
        checkboxSelection: true,
      },
    ];

    this.columnDefs = newData;
    this.loadTable = 1;

    if (this.gridApi) {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
      this.gridApi.refreshHeader();
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
        Global.setHeaderIds(this.headerIdMap);
      }, 0);
      this.onGridReady(this.gridParams);
    }
  }

  dateFormateChange(params: any) {
    if (params.data && params.data.createdDate !== undefined) {
      const dateFormat: any = localStorage.getItem('date_format');
      return moment
        .tz(params.data.createdDate, dateFormateChange)
        .format(' hh:mm A ' + dateFormat.toUpperCase());
    }
    return '';
  }

  getFilterData() {
    this.push(
      this.assetService.getTypes(true).subscribe((res: any) => {
        this.assetTypes = res.body.sort((elementA: any, elementB: any) => {
          if (elementA.order > elementB.order) return 1;
          if (elementA.order < elementB.order) return -1;
          return 0;
        });
      })
    );

    this.push(
      this.assetService.getStatuses(true).subscribe((res: any) => {
        this.assetStatus = res.body.sort((elementA: any, elementB: any) => {
          if (elementA.order > elementB.order) return 1;
          if (elementA.order < elementB.order) return -1;
          return 0;
        });
      })
    );
  }

  public onDateChange(event: any) {
    if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
      this.filter.fromDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
      this.filter.toDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
      this.myCalendar.hideOverlay();
      this.quickSearch();
    }

    if (event === null) {
      this.filter.fromDate = null;
      this.filter.toDate = null;
      this.quickSearch();
    }
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewChecked() {
    this.bodyHeight =
      window.innerHeight - this.topElement.nativeElement.offsetHeight - 350;
    this.bodyHeightleft =
      window.innerHeight - this.topElement.nativeElement.offsetHeight - 180;
    this.cdr.detectChanges();
  }

  setSearch() {
    if (this.searchValue?.length > 0) {
      this.searchValueData = true;
      this.quickSearch();
    }
  }

  public onSearch() {
    if (this.searchValue?.length == 0) {
      this.searchValueData = false;
      this.searchValue = '';
      this.quickSearch();
    }
  }

  public onClear() {
    this.searchValueData = false;
    this.searchValue = '';
    this.quickSearch();
  }

  quickSearch() {
    this.onGridReady(this.gridParams);
  }

  onGridReady(params: any) {
    if (params != undefined) {
      this.gridParams = params;
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();

      const dataSource: IDatasource = {
        getRows: (params: IGetRowsParams) => {
          if (this.loadTable == 1) {
            this.getServerSideData(params);
          }
        },
      };

      this.gridApi.sizeColumnsToFit();
      this.gridApi.setGridOption('datasource', dataSource);
    }
  }

  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

    this.push(
      this.qrExportService
        .getAssetListByFilter(
          this.searchValue,
          this.filter.assetTypes,
          this.filter.assetStatuses,
          this.filter.fromDate,
          this.filter.toDate,
          serverRequest
        )
        .subscribe(
          (data: any) => {
            this.assets = data.body.data;
            this.totalRecords = data.body.total;
            this.setGridData(
              agGridGetRowsParams,
              this.assets,
              data.body.total,
              data.body.status
            );
          },
          (err) => {
            this.errorUtil.setErrorMessage(err);
          }
        )
    );
  }

  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    if (status === 'NO_DATA') {
      this.noAssets = false;
      this.noAssetsIcon = true;
      this.gridApi.showNoRowsOverlay();
    } else {
      this.noAssets = true;
      this.noAssetsIcon = false;

      if (this.assets.length === 0) {
        this.gridApi.showNoRowsOverlay();
      } else {
        this.gridApi.hideOverlay();
        agGridGetRowsParams.successCallback(this.assets, totalCount);
        this.restoreSelection();
      }
    }
  }

  getRequestParams(agGridRequest: IGetRowsParams): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: 'runningNo', sort: 'desc' };
      agGridRequest.sortModel.push(this.parameters);
    }

    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  private restoreSelection() {
    if (!this.gridApi) return;

    this.gridApi.forEachNode((node: any) => {
      const id = node?.data?.id;
      if (id == null) return;
      const shouldBeSelected = this.selectedIdSet.has(id);
      if (node.isSelected() !== shouldBeSelected) {
        node.setSelected(shouldBeSelected);
      }
    });
  }

  selectAll() {
    if (this.selectAllChecked) {
      this.overlayNoRowsTemplate =
        "<div class='not-found-image-asset'><span>" +
        this.totalRecords +
        " assets have been selected </span>" +
        "<img src='assets/svg/Asset-AllSelected.svg' alt='No Records Found' />" +
        '<span>Uncheck “select all” to view the whole list again</span></div>';

      if (this.gridApi) {
        setTimeout(() => {
          this.gridApi.showNoRowsOverlay();
        }, 500);
      }
    } else {
      this.overlayNoRowsTemplate =
        "<div class='not-found-image'><span>" +
        "<img src='assets/svg/empty-state.svg' alt='No Records Found' />" +
        this.translate?.general.messages.noRecordsFound +
        '</span> </div>';
      this.gridApi.hideOverlay();
    }
  }

  onRowSelected(event: any) {
    const id = event?.data?.id;
    if (id == null) return;

    if (event.node.isSelected()) this.selectedIdSet.add(id);
    else this.selectedIdSet.delete(id);
  }

  private onSelectionChanged() {
    const rows: any[] = [];
    this.gridApi.forEachNode((n: any) => {
      if (n.isSelected() && n.data) rows.push(n.data);
    });
    this.selectedAssetData = rows;
  }

  onQrCodeSizeChange() {
    this.exportData.selectedPageLayout = null;

    if (
      this.exportData.selectedQrCodeSize == 'large' ||
      this.exportData.selectedQrCodeSize == 'xlarge'
    ) {
      _.remove(this.filePageLayout, (n: any) => n.value == 'a5');
      return this.filePageLayout.filter((layout: any) => layout.value !== 'a5');
    } else {
      this.filePageLayout = _.cloneDeep(this.pageLayout);
    }
  }

  qrPixelSize(size: 'small' | 'medium' | 'large' | 'xlarge' | null) {
    switch (size) {
      case 'small':
        return 220;
      case 'medium':
        return 300;
      case 'large':
        return 450;
      case 'xlarge':
        return 600;
      default:
        return 300;
    }
  }

  trackByAsset = (_: number, a: any) => a?.id ?? a?.assetId ?? a?.assetCode ?? a;

  getQrPayload(serialNo: any): any {
    return serialNo;
  }

  private collectQrItems(): Array<{ url: string; label: string }> {
    const items: Array<{ url: string; label: string }> = [];
    this.qrItems?.forEach((el) => {
      const host = el.nativeElement as HTMLElement;
      const canvas = host.querySelector('canvas') as HTMLCanvasElement | null;
      const label = (
        host.getAttribute('data-label') ||
        host.querySelector('.qr-label')?.textContent ||
        ''
      ).trim();
      if (canvas) {
        items.push({ url: canvas.toDataURL('image/png'), label });
      }
    });
    return items;
  }

  private gridForLayout(layout: 'portrait' | 'landscape' | 'a4' | 'a5') {
    switch (layout) {
      case 'portrait':
        return { cols: 2, rows: 2, orientation: 'p' as const };
      case 'landscape':
        return { cols: 3, rows: 2, orientation: 'l' as const };
      case 'a4':
        return { cols: 4, rows: 3, orientation: 'p' as const };
      case 'a5':
        return { cols: 6, rows: 4, orientation: 'l' as const };
      default:
        return { cols: 3, rows: 2, orientation: 'p' as const };
    }
  }

  private async exportPdfFromDataUrls(
    items: Array<{ url: string; label: string }>
  ) {
    const sizeMm = this.sizeMmMap[this.exportData.selectedQrCodeSize];
    const { cols, rows, orientation } = this.gridForLayout(
      this.exportData.selectedPageLayout
    );
    const marginMm = 10;

    const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const cellW = (pageW - marginMm * 2) / cols;
    const cellH = (pageH - marginMm * 2) / rows;
    const qrBox = Math.min(cellW, cellH);
    const qrRenderMm = Math.min(qrBox, sizeMm);

    let textPadding = 10;

    if (this.exportData.selectedQrCodeSize === 'small') {
      textPadding = 7;
      doc.setFontSize(15);
    } else if (this.exportData.selectedQrCodeSize === 'medium') {
      doc.setFontSize(12);
    } else if (this.exportData.selectedQrCodeSize === 'large') {
      doc.setFontSize(14);
    } else if (this.exportData.selectedQrCodeSize === 'xlarge') {
      doc.setFontSize(14);
    }

    for (let i = 0; i < items.length; i++) {
      const idxOnPage = i % (cols * rows);
      const col = idxOnPage % cols;
      const row = Math.floor(idxOnPage / cols);
      if (i > 0 && idxOnPage === 0) doc.addPage();

      const x0 = marginMm + col * cellW;
      const y0 = marginMm + row * cellH;

      const qrX = x0 + (cellW - qrRenderMm) / 2;
      const qrY = y0 + (cellH - qrRenderMm) / 2;

      doc.addImage(
        items[i].url,
        'PNG',
        qrX,
        qrY,
        qrRenderMm,
        qrRenderMm,
        undefined,
        'FAST'
      );

      const labelY = qrY + qrRenderMm + textPadding;
      const maxTextWidth = cellW - 4;
      const wrapped = doc.splitTextToSize(items[i].label || '', maxTextWidth);
      const centerX = x0 + cellW / 2;
      doc.text(wrapped, centerX, labelY, { align: 'center' });
    }

    doc.save('Asset-QR-Export.pdf');
    this.clearSelections();
  }

  private async exportZipFromDataUrls(
    items: Array<{ url: string; label: string }>
  ) {
    const zip = new JSZip();
    items.forEach((it, i) => {
      const safe = (it.label || `qr-${i + 1}`).replace(/[^\w.-]/g, '_');
      zip.file(`${safe}.png`, it.url.split(',')[1], { base64: true });
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    saveAs(blob, 'Asset-QR-Export.zip');
    this.clearSelections();
  }

  disabledSelectAll(): boolean {
    if (
      this.dateRange ||
      this.filter.assetStatuses ||
      this.filter.assetTypes ||
      this.searchValue
    ) {
      return false;
    } else {
      return true;
    }
  }

  enableSubmit(): boolean {
    if (
      this.exportData.selectedFileFormat &&
      this.exportData.selectedQrCodeSize &&
      this.exportData.selectedPageLayout &&
      (this.selectedIdSet.size > 0 || this.selectAllChecked)
    ) {
      return false;
    } else {
      return true;
    }
  }

  submitForm() {
    if (this.selectAllChecked) {
      this.selectedAssetData = [];
      this.selectedIdSet.clear();
    }

    this.spinner.show();
    const req = _.cloneDeep(this.submitFromData);

    req.selectedIds =
      this.selectedIdSet.size > 0 ? Array.from(this.selectedIdSet) : [];
    req.selectedAll = this.selectAllChecked;
    req.includeChildren = this.submitFromData.includeChildren;
    req.search = this.searchValue || null;
    req.assetTypeIds = this.filter.assetTypes ? this.filter.assetTypes : null;
    req.statusId = this.filter.assetStatuses ? this.filter.assetStatuses : null;
    req.createdFrom = this.util
      .timeFormatter(
        moment('00:00:00', 'h:mm A').format('h:mm A'),
        moment(this.filter.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
      )
      .toISOString();
    req.createdTo = this.util
      .timeFormatter(
        moment('00:00:00', 'h:mm A').format('h:mm A'),
        moment(this.filter.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
      )
      .toISOString();

    this.qrExportService.getAssetSerialNumbers(req).subscribe(
      (res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.selectedAssetserialNos = res.body;
          
            this.selectedAssetserialNos.forEach((element: any) => {
               element.displaySerialNo = element.serialNo;
              
            if(this.addonFeature.addonQRSCANFORM === 'QR_SCAN_FORM'){
              element.serialNo = environment.qrFromUrl + "?tenantId=" + this.encryptedTenantId + "&serialNo=" + element.displaySerialNo + "&lang=" + this.lang+"&formType=asset";
            } else {
              element.serialNo = element.serialNo;
            }
            });
          

          setTimeout(() => {
            this.exportQrCodes();
          }, 2000);
        } else {
          const title = this.errorUtil.processErrorTitle(
            res.error,
            this.translate
          );
          this.errorUtil.setErrorMessage(
            res.status,
            null,
            title,
            'error',
            3000
          );
          this.submitTouched = false;
        }
      },
      (err) => {
        this.spinner.hide();
        const title = this.errorUtil.processErrorTitle(err.error, this.translate);
        this.errorUtil.setErrorMessage(err.status, null, title, 'error', 3000);
      }
    );
  }

  async exportQrCodes() {
    try {
      await Promise.resolve();
      const items = this.collectQrItems();
      if (!items.length) {
        this.errorUtil.setErrorMessage(
          400,
          null,
          'Could not render QR codes.',
          'error',
          2000
        );
        return;
      }

      if (this.exportData.selectedFileFormat === 'pdf') {
        await this.exportPdfFromDataUrls(items);
      } else {
        await this.exportZipFromDataUrls(items);
      }
    } catch (e) {
      this.errorUtil.setErrorMessage(400, null, e, 'error', 2000);
    } finally {
      this.spinner.hide();
    }
  }

  clearSelections() {
    this.errorUtil.setErrorMessage(
      400,
      null,
      'QR code(s) successfully downloaded',
      'success',
      2000
    );
    this.modalRef.hide();
    this.selectedIdSet.clear();
    this.selectedAssetData = [];
    this.selectAllChecked = false;
    this.submitFromData.includeChildren = false;
    this.exportData.selectedAssets = [];
    this.filter.assetTypes = null;
    this.filter.assetStatuses = null;
    this.filter.fromDate = null;
    this.filter.toDate = null;
    this.searchValue = null;
    this.qrexportForm.reset();
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }

  clearFilter() {
    this.filter.assetTypes = null;
    this.filter.assetStatuses = null;
    this.filter.fromDate = null;
    this.filter.toDate = null;
    this.searchValue = null;
    this.searchValueData = false;
    this.dateRange = null;
    this.myCalendar?.hideOverlay();
    this.quickSearch();
  }

  clearSelect() {
    this.selectedIdSet.clear();
    this.selectedAssetData = [];
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }
}